export type CEFR = "A1" | "A2" | "B1" | "B2" | "C1" | "C2";

export type VocabWord = { term: string; meaning: string };

export type VocabGroup = {
  id: string;
  title: string;
  tiers: Partial<Record<CEFR, VocabWord[]>>;
};

// Functional words needed for sentence building
export const functionalWords: VocabGroup[] = [
  {
    id: "connectors",
    title: "Connectors & Fillers",
    tiers: {
      A1: [
        { term: "y", meaning: "and" },
        { term: "o", meaning: "or" },
        { term: "pero", meaning: "but" },
        { term: "porque", meaning: "because" },
        { term: "también", meaning: "also/too" },
        { term: "muy", meaning: "very" },
      ],
      A2: [
        { term: "aunque", meaning: "although" },
        { term: "entonces", meaning: "then/so" },
        { term: "además", meaning: "in addition" },
      ],
      B1: [
        { term: "sin embargo", meaning: "however" },
        { term: "por lo tanto", meaning: "therefore" },
        { term: "así que", meaning: "so/therefore" },
      ],
      B2: [
        { term: "no obstante", meaning: "nevertheless" },
        { term: "en consecuencia", meaning: "consequently" },
        { term: "por consiguiente", meaning: "consequently" },
      ],
    },
  },
  {
    id: "conjunctions",
    title: "Conjunctions",
    tiers: {
      A1: [
        { term: "que", meaning: "that/which" },
        { term: "si", meaning: "if" },
      ],
      A2: [
        { term: "cuando", meaning: "when" },
        { term: "mientras", meaning: "while" },
      ],
      B1: [
        { term: "aunque", meaning: "although" },
        { term: "mientras que", meaning: "whereas" },
      ],
      B2: [
        { term: "con tal de que", meaning: "provided that" },
        { term: "a menos que", meaning: "unless" },
      ],
    },
  },
];

// Keep the old vocabGroups for backward compatibility with sentence practice
export const vocabGroups = functionalWords;


